import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getUsersAll } from 'modules/_common/api';

export const useQueryUsersAll = () => {
  return useQuery(QUERY_KEYS.RENTALS_USERS_ALL, getUsersAll, getCacheSettings());
};
